import script from "./NPresence.vue?vue&type=script&setup=true&lang=js"
export * from "./NPresence.vue?vue&type=script&setup=true&lang=js"

import "./NPresence.vue?vue&type=style&index=0&id=55d31956&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d31956"]])

export default __exports__